import bankOfAmericaLogo from '@/assets/institutions/bank-of-america.png'
import mercuryLogo from '@/assets/institutions/mercury.png'
import novoLogo from '@/assets/institutions/novo.png'
import relayLogo from '@/assets/institutions/relay.png'

/**
 * Institution logos keyed by display name, for surfaces that have an
 * institution's *name* but no linked `PlaidItem` to read `institution.logo`
 * from: manual accounts, and the pre-signup readiness intake.
 *
 * The bundled files were pulled from Plaid's own institution metadata
 * (`institutionsGetById` with `include_optional_metadata`), so they are the
 * same marks the Financial Institutions page renders once an account is
 * linked. Bundled rather than fetched because the intake asks which bank you
 * use before any Plaid link exists.
 *
 * `Relay` is keyed by the label the intake shows, not Plaid's own
 * "Relay Financial", and deliberately so: searching Plaid for "Relay" returns
 * "RelayGO Card" (relaypayments.com, freight payments) first, which is a
 * different company entirely.
 */
export const institutionLogoMap: Record<string, string> = {
  Chase:
    'https://heard-images.s3.us-west-1.amazonaws.com/assets/chase-logo.png',
  'Wells Fargo':
    'https://heard-images.s3.us-west-1.amazonaws.com/assets/wellsfargo-logo.png',
  'Citibank Online':
    'https://heard-images.s3.us-west-1.amazonaws.com/assets/citibank-logo.png',
  // Lookup is by exact name: Plaid says "Citibank Online", the intake says
  // "Citibank", and both have to resolve.
  Citibank:
    'https://heard-images.s3.us-west-1.amazonaws.com/assets/citibank-logo.png',
  'Capital One':
    'https://heard-images.s3.us-west-1.amazonaws.com/assets/capitalone-logo.png',
  'U.S. Bank':
    'https://heard-images.s3.us-west-1.amazonaws.com/assets/usbank-logo.png',
  Bluevine:
    'https://heard-images.s3.us-west-1.amazonaws.com/assets/bluevine-logo.png',
  'Bank of America': bankOfAmericaLogo,
  Novo: novoLogo,
  Mercury: mercuryLogo,
  Relay: relayLogo,
}

/**
 * Logos for the practice-management / EHR systems the readiness intake asks
 * about, keyed by the option label shown there.
 *
 * Kept separate from `institutionLogoMap` on purpose: that map is the
 * financial-institution lookup the Financial Institutions page falls back to
 * for manual accounts, and an EHR is not an institution. Merging them would
 * make a therapy-notes app resolvable as a bank.
 */
export const practiceSoftwareLogoMap: Record<string, string> = {
  SimplePractice:
    'https://heard-images.s3.amazonaws.com/assets/simplepractice-com-logo.png',
  TherapyNotes:
    'https://heard-images.s3.amazonaws.com/assets/therapynotes-com-logo.png',
  Jane: 'https://heard-images.s3.amazonaws.com/assets/jane-app-logo.png',
}
